import application from "stimulus_application";
import ClientsContainerController from "./clients_container_controller";
import "./clients_container.css";

application.register("clients-container", ClientsContainerController);
